import { CartItemType } from '@zola-helpers/client/dist/es/@types/cart';

function getPrecision(dollarAmount: number) {
  const hasCents = dollarAmount % 1 !== 0;
  return hasCents ? 2 : 0;
}

export const compactCurrencyFilter = (price: number | null | undefined) => {
  if (typeof price === 'undefined' || price === null) {
    return '';
  }
  if (price === 0) {
    return 'Free';
  }
  return `$${price
    .toFixed(getPrecision(price))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

export const hasDiscountedPrice = (item: CartItemType) =>
  (item.contribution?.price || 0) > (item.contribution?.adjustedPrice || 0);

export default compactCurrencyFilter;
